import {
	LevelOfPlayEnum,
	SportsEnum,
	ResourceGlDto,
	Product,
	ShallowUpdateProgramSeasonDto,
	RegistrationConstraintPeriodTypeEnum,
	SimpleFacilityDto,
	MediaDto,
	CreateProgramSeasonDto,
} from '@bondsports/types';
import { ResourceSettingsDto, RosterRolloverModeEnum } from './resourceSettings';
import { PublishingStatusEnum } from './season';
import { IGlCodeItem } from '@app/react/types/glCodes';

export interface Session {
	GL?: string;
	glCodes?: ResourceGlDto[];
	activityTimes; //
	address; //
	addressId: number;
	blockedDated; //
	description: string;
	earlyRegistrationEndDate;
	earlyRegistrationStartDate;
	endDate?: string;
	facilityId: number;
	facilityName: string;
	gender: number;
	id: number;
	isPunchCard: boolean;
	lateRegistrationEndDate; //
	lateRegistrationStartDate; //
	level; //
	linkSEO: string;
	longDescription: string;
	maxAge: string;
	maxFemaleParticipants;
	maxFemaleWaitlist;
	maxMaleParticipants;
	maxMaleWaitlist;
	maxParticipants;
	maxWaitlist;
	minAge: string;
	name: string;
	organizationId: number;
	parentSeasonId: number;
	programId: number;
	questionnaires; //
	registrationConstraints;
	registrationEndDate?: string;
	registrationStartDate?: string;
	requiredProductIds;
	seasonType: number;
	programType: number;
	spaces; //
	sport: number;
	startDate?: string;
	status: PublishingStatusEnum;
	colorCodeId?: number;
	ageCalcDate: string;
	customAgeCalc: string;
	products: Product[];
	// Resource settings and its corresponding props for the form
	resourceSettings?: ResourceSettingsDto[];
	isHideEventTimes?: boolean;
	isHideSeasonSchedule?: boolean;
	mainMedia?: MediaDto;
}

export interface IEditSessionValues {
	yearOrMonthsMin?: string;
	yearOrMonthsMax?: string;
	minAge?: number;
	maxAge?: number;
	ageCalcDate?: string;
	customAgeCalc?: boolean;
	gender?: number;
	levelOfPlay?: LevelOfPlayEnum[];
	sport?: SportsEnum;
	name?: string;
	description?: string;
	longDescription?: string;
	glCodes?: IGlCodeItem[];
	id?: number;
	programId?: number;
	facility?: SimpleFacilityDto;
	is_maxParticipants?: boolean;
	is_maxMaleParticipants?: boolean;
	is_maxFemaleParticipants?: boolean;
	maxParticipants?: number;
	maxMaleParticipants?: number;
	maxFemaleParticipants?: number;
	requiredProductIds?: number[];
	memberships?: number[];
	colorCodeId?: number;
	isHideEventTimes?: boolean;
	isHideSeasonSchedule?: boolean;
	waitlistSettings?: {
		enabled: boolean;
	};
	isDisplayRemainingSpots?: boolean;
	rosterRolloverMode?: RosterRolloverModeEnum;
	mainMedia?: MediaDto | null;
}

export interface IShallowEditSession extends ShallowUpdateProgramSeasonDto {
	resourceSettings?: ResourceSettingsDto[];
}

export interface RegistrationSettingsDto {
	registrationStartDate: string;
	registrationEndDate: string;
	earlyRegistrationStartDate?: string;
	earlyRegistrationEndDate?: string;
	lateRegistrationStartDate?: string;
	lateRegistrationEndDate?: string;
	closeRegistrationPeriodValue?: number;
	closeRegistrationPeriodType?: RegistrationConstraintPeriodTypeEnum;
	closeRegistrationSpecTime?: string;
	openRegistrationPeriodValue?: number;
	openRegistrationPeriodType?: RegistrationConstraintPeriodTypeEnum;
	openRegistrationSpecTime?: string;
	productsIdsToUpdate?: number[];
}

//TODO: will be removed once apiv2 for this feature is merged and we can pull down types
export type ICreateSession = (
	Omit<CreateProgramSeasonDto, keyof RegistrationSettingsDto> &
	RegistrationSettingsDto
) & {
	resourceSettings?: ResourceSettingsDto[];
	mainMedia?: MediaDto;
	mainMediaId?: number | null;
};

export enum RegistrationStatusEnum {
	FUTURE = 'future',
	OPEN = 'open',
	CLOSE = 'close',
}

export interface SessionMenuProps {
	duplicateSession: boolean;
	notifyAttendees: boolean;
	archiveSession: boolean;
}

export interface SessionColumnDef {
	id: number;
	sessionName: string;
	imageUrl?: string;
	ageRange: string;
	startDate: string;
	endDate: string;
	registrationStartDate: string;
	registrationEndDate: string;
	facilityName: string;
	facilityId: number;
	registrationStatus: RegistrationStatusEnum;
	sessionStatus: PublishingStatusEnum;
	publicLink: string;
	sessionType: number;
	programType: number;
	more: SessionMenuProps;
}
